import { useEffect } from 'react';
import { NOTICE_AUTO_DISMISS_MS } from '../constants';

/**
 * Clears a transient notice/banner after `delayMs` whenever `message` is set.
 * Resets the timer if a new message arrives before the previous one expires.
 */
export function useAutoDismissNotice(
  message: string | null | undefined,
  clear: () => void,
  delayMs: number = NOTICE_AUTO_DISMISS_MS
): void {
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(clear, delayMs);
    return () => window.clearTimeout(timer);
  }, [message, clear, delayMs]);
}
